<template>
  <div class="loading-overlay" v-if="isVisible">
    <div class="loading-content">
      <div class="px-4 py-2 secondary lighten-1 secondary font-weight-medium text-center" style="font-size: 14px; border-radius: .3em; width: 100%">
        <span class="t-bw-secondary--text">{{ loadingMessage }}</span>
        <v-progress-circular class="ml-2" indeterminate color="t-bw-secondary" size="20" width="3"></v-progress-circular>
      </div>
      <!-- <v-progress-circular
        indeterminate
        size="64"
        width="4"
        color="primary"
      ></v-progress-circular>
      <div class="mt-4 loading-text">
        {{ loadingMessage }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { resolverEvents } from '@/router/route-resolvers';
import i18n from "@/plugins/i18n"

export default {
  name: 'LoadingOverlay',
  
  data() {
    return {
      isVisible: false,
      loadingMessage: i18n.t('dashboard.notifications.loadRequiredData'),
      currentRoute: ''
    }
  },
  
  created() {
    // Listen for resolver events
    resolverEvents.$on('resolver:start', ({ routeName }) => {
      console.log('LoadingOverlay: resolver:start event received for', routeName);
      this.isVisible = true;
      this.currentRoute = routeName;
    });
    
    resolverEvents.$on('resolver:end', ({ routeName }) => {
      console.log('LoadingOverlay: resolver:end event received for', routeName);
      if (this.currentRoute === routeName) {
        // Add small delay to make transition smoother
        setTimeout(() => {
          this.isVisible = false;
        }, 300);
      }
    });
    
    resolverEvents.$on('resolver:error', ({ routeName }) => {
      console.log('LoadingOverlay: resolver:error event received for', routeName);
      if (this.currentRoute === routeName) {
        this.isVisible = false;
      }
    });
  },
  
  mounted() {
    console.log('LoadingOverlay mounted, isVisible:', this.isVisible);
  },
  
  beforeDestroy() {
    resolverEvents.$off('resolver:start');
    resolverEvents.$off('resolver:end');
    resolverEvents.$off('resolver:error');
  }
}
</script>

<style lang="scss" scoped>
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  animation: fadeIn 0.3s ease;
  
  .loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 48px;
  }
  
  .loading-text {
    font-size: 16px;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.7);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>